// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"Profile_cardTitle__26tPw","actions":"Profile_actions__1W2na"};